/**
 * Bundle types
 */
export const BUNDLE_TYPE_COMBO = 'combo';
export const BUNDLE_TYPE_PACKAGE = 'package';

/**
 * Experience types
 */
export const EXPERIENCE_TYPE_GM = 'generic';
export const EXPERIENCE_TYPE_KITCHEN = 'kitchen';
export const EXPERIENCE_TYPE_LAUNDRY = 'laundry';